import { Component, OnInit } from '@angular/core';
import { HttpDashboardService } from '../../service/http-dashboard.service';
import { AbstractDashboardDto, DashboardDateRangeDto, PartnerDto } from '../../service/dto';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { HttpPartnerService } from '../../service/http-partner.service';
import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import { finalize } from 'rxjs';

@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrl: './home.component.scss',
	standalone: false
})
export class HomeComponent implements OnInit {
	startModel!: NgbDateStruct;
	endModel!: NgbDateStruct;
	partners: PartnerDto[] = [];
	selectedPartner?: PartnerDto;
	faCalendar = faCalendar;
	loading = false;

	data: AbstractDashboardDto[] = [];
	activeAgentCount?: AbstractDashboardDto;
	activeAgentSessions?: AbstractDashboardDto;
	pendingApprovals?: AbstractDashboardDto;
	registrationActiveCount?: AbstractDashboardDto;
	registrationPerPartner?: AbstractDashboardDto;
	registrationSimStatus?: AbstractDashboardDto;
	registrationCount?: AbstractDashboardDto;
	agentStatusDistribution?: AbstractDashboardDto;
	thirdPartyApiCallCount?: AbstractDashboardDto;
	thirdPartyThroughput?: AbstractDashboardDto;
	dataFileRecordsPendingImport?: AbstractDashboardDto;
	dataFileRecordsProcessing?: AbstractDashboardDto;
	dateRange?: DashboardDateRangeDto;

	constructor(private service: HttpDashboardService) { }

	ngOnInit(): void {
		let startDate = new Date();
		startDate.setMonth(startDate.getMonth() - 1);

		this.startModel = {
			year: startDate.getFullYear(),
			month: startDate.getMonth()+1,
			day: startDate.getDate()
		};

		let endDate = new Date();
		this.endModel = {
			year: endDate.getFullYear(),
			month: endDate.getMonth() + 1,
			day: endDate.getDate()
		};
		this.service.getAvailablePartners().subscribe(result => {
			this.partners = result;
			if (this.partners.length == 1) {
				this.selectedPartner = this.partners[0];
			}
			this.update();
		});
	}

	update() {

		let startDate = `${this.startModel.year}-`;
		if (this.startModel.month < 10) {
			startDate += '0';
		}
		startDate += `${this.startModel.month}-`;
		if (this.startModel.day < 10) {
			startDate += '0';
		}
		startDate += `${this.startModel.day}`;


		let endDate = `${this.endModel.year}-`;
		if (this.endModel.month < 10) {
			endDate += '0';
		}
		endDate += `${this.endModel.month}-`;
		if (this.endModel.day < 10) {
			endDate += '0';
		}
		endDate += `${this.endModel.day}`;


		this.loading = true;
		this.service.getData(startDate, endDate, this.selectedPartner)
			.pipe(finalize(() => this.loading = false))
			.subscribe(result => {
				this.data = result;
				this.activeAgentCount = this.data.filter(item => item.name == 'ActiveAgentCount')[0];
				this.activeAgentSessions = this.data.filter(item => item.name == 'ActiveAgentSessions')[0];
				this.agentStatusDistribution = this.data.filter(item => item.name == 'AgentStatusDistribution')[0];
				this.pendingApprovals = this.data.filter(item => item.name == 'PendingApprovals')[0];
				this.registrationActiveCount = this.data.filter(item => item.name == 'RegistrationActiveCount')[0];
				this.registrationPerPartner = this.data.filter(item => item.name == 'RegistrationPerPartner')[0];
				this.registrationSimStatus = this.data.filter(item => item.name == 'RegistrationSimStatus')[0];
				this.registrationCount = this.data.filter(item => item.name == 'RegistrationCount')[0];
				this.thirdPartyApiCallCount = this.data.filter(item => item.name == 'ThirdPartyApiCallCount')[0];
				this.thirdPartyThroughput = this.data.filter(item => item.name == 'ThirdPartyThroughput')[0];
				this.dataFileRecordsPendingImport = this.data.filter(item => item.name == 'DataFileRecordsPendingImport')[0];
				this.dataFileRecordsProcessing = this.data.filter(item => item.name == 'DataFileRecordsProcessing')[0];
				this.dateRange = this.data.filter(item => item.name == 'DashboardDateRangeDto')[0] as DashboardDateRangeDto;
			});
	}
}
